import Navbar from "../../components/Navbar"
function FirstPage() {
  return (
    <div id="hero">
      <img src="/images/circles.png" className="absolute z-[-1]" alt="large circles" />
      <img
        src="/images/bg-gradient-img.png"
        className="absolute z-[-1]  right-[20%] sm:left-[0%]"
        alt="green gradient"
      />
      <img
        src="/images/bg-gradient-purple3.png"
        className="absolute z-[-1] top-[20%]   right-[0%]"
        alt=""
      />
      <div className="pb-14">
        <Navbar />
      </div>
      <div id="icons-container" className="flex pb-28 sm:pb-0">
        <div id="left-col">
          {/* Bitcoin Image */}
          <img src="/images/Bitcoin-1.png" alt="Bitcoin" className="relative md:left-[20%]" />
          <img
            src="/images/new-start-eight.png"
            alt="star eight sided"
            className="relative w-12 sm:w-auto top-[8%] sm:top-0 left-[20%] sm:left-[50%] lg:left-[100%]"
          />
          {/* Brown Sphere Left */}
          <img
            src="/images/sphere-brown.png"
            alt="Brown Sphere"
            className="transition-on-hover relative top-[25%] sm:top-[12%] lg:left-[70%]"
          />
          {/* Lite Coin Bottom Left */}
          <img
            src="/images/LiteCoin-1.png"
            alt="Lite Coin"
            className="relative top-[55%]  sm:top-[18%] left-[30%] sm:left-[100%]"
          />
        </div>
        {/* Hero text */}
        <div
          id="hero__content"
          className="w-[100%] sm:w-[55%] mx-auto flex flex-col gap-y-20 sm:gap-y-40 items-center justify-center sm:max-h-[42rem]"
        >
          <h1 className="sm:max-w-[75%] xl:max-w-[60%] max-w-[85%]  transform scale-125 text-white text-4xl lg:text-5xl xl:text-6xl font-extrabold text-center ">
            We make crypto clear and simple
          </h1>
          <button className="py-2 sm:py-4 px-5 sm:px-8 text-white bg-gradient-to-tr from-[#933FFE] to-[#18C8FF] rounded-lg transition-all cursor-pointer hover:translate-y-2">
            Get Started
          </button>
        </div>

        <div id="right-col">
          {/* Start four Sided Right Top */}
          <img
            src= "/images/star-img.png"
            alt="star four sided"
            className="relative w-14 bottom-[6%] sm:w-auto sm:bottom-[0%] lg:right-[50%]"
          />
          {/* Star six Sided small Right Top */}
          <img
            src="/images/star-six-sided.png"
            alt="star six sided"
            className="w-10 sm:w-14  relative  sm:bottom-[5%] lg:left-[10%] left-[50%]"
          />
          {/* Monero Coin */}
          <img
            src="/images/monero-coin.png"
            alt="Star"
            className="relative top-[6%] sm:top-[0%]  lg::right-[55%]"
          />
          {/* Etherium Coin */}
          <img
            src="/images/etherium-coin.png"
            alt="Star"
            className="relative top-[56%] sm:top-[20%]  right-[70%] lg:right-[180%]"
          />
          {/* Purple Sphere Right*/}
          <img
            src="/images/sphere-purple.png"
            alt="Star"
            className=" relative sm:-top-[20%]"
          />
          {/* Star eight Sided Right bottom appears on scroll */}
          <img
            src="/images/new-start-eight.png"
            alt="star eight sided"
            className="relative w-12 sm:w-auto top-[25%] sm:-top-[10%] left-[20%] sm:left-[0%]"
          />
        </div>
      </div>
    </div>
  );
}
export default FirstPage;
